'use strict';

define('vb/extensions/dynamic/private/types/containerMetadataProviderDescriptor',[
  'vb/extensions/dynamic/private/types/abstractMetadataProviderDescriptor',
  'vb/extensions/dynamic/private/types/bridges/helperMetadataProviderFactoryBridge',
  'vb/extensions/dynamic/private/models/dynamicContainer',
],
(AbstractMetadataProviderDescriptor, HelperMetadataProviderFactoryBridge, DynamicContainer) => {
  /**
   * @typedef {import(
   *   'vb/extensions/dynamic/private/types/bridges/metadataProviderFactoryBridge'
   * ).default} MetadataProviderFactoryBridge
   */

  /**
   * VB "metadata" variable for JET Dynamic Container support.
   */
  class ContainerMetadataProviderDescriptor extends AbstractMetadataProviderDescriptor {
    /**
     * creates an 'options' object that is used both by the FactoryMetadataProviderDescriptor, and
     * the VB metadata provider helper.
     *
     * Properties used by FactoryMetadataProviderDescriptor:
     *
     * factory:      path to the JET (or VB proxy) metadata provider factory
     * helper.class: path for the VB metadata provider helper, passed to the Metadata provider
     *
     * properties used by the ConfigurableMetadataProviderHelper
     * helper.root:  base path for the resources used by the metadata provider helper; the "page" folder
     * helper.resources: a set of objects that describe the resources served to the JET provider
     *
     * helper.resources.files: all other files, returned by getLayoutResources as an array of named objects.
     *
     * @param value {object}
     * @returns {Object}
     */
    createOptions(value) {
      let options = super.createOptions(value);

      if (!options.factory) {
        const extensions = {};
        const container = this.container;

        if (!container) {
          throw new Error('Missing container when creating MetadataProvider');
        }

        container.extensionsArray.forEach((containerExt) => {
          extensions[containerExt.extensionId] = {
            container: containerExt,
            property: 'data',
          };
        });

        // no 'metadata' for container, just files
        const descriptors = [{
          resourceName: `${container.fullName}-template`,
          propertyMap: {
            descriptor: 'data',
            template: 'template',
            viewModel: 'dataModel',
          },
          modelClass: DynamicContainer,
          container,
        }];

        options = Object.assign({}, options, {
          factory: 'oj-dynamic/providers/ContainerMetadataProviderFactory',
          helper: {
            class: 'vb/extensions/dynamic/private/helpers/configurableMetadataProviderHelper',
            root: container.resourceLoc, // should be the resource path relative to the baseUrl
            descriptors,
          },
        });
      }

      return options;
    }

    /**
     * @returns {MetadataProviderFactoryBridge}
     */
    // eslint-disable-next-line class-methods-use-this
    createFactoryBridge() {
      return new HelperMetadataProviderFactoryBridge();
    }

    /**
     * Returns the type definition object for the ContainerMetadataProviderDescriptor.
     *
     * @returns {{type: 'any'}}
     */
    // eslint-disable-next-line class-methods-use-this
    getTypeDefinition() {
      return {
        type: 'any', // needed this for some reason, couldn't return null, stateUtils wouldn't call init()
      };
    }
  }

  return ContainerMetadataProviderDescriptor;
});

